import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import salaryApi from 'src/api/salary'

export const fetchAllSalary = createAsyncThunk(
  'product/fetchAllSalary',
  async () => {
    const response = await salaryApi.getAllSalary()
    return response
  }
)

const initialState = {
  isModalOpen: false,
  modalViewName: null,
  modalViewParams: null,
  detail: null,
  reload: false,

  status: '',
  allSalary: [],
  loading: true,
  error: '',
}
const slice = createSlice({
  name: 'salary',
  initialState,
  reducers: {
    addSalary(oldState, action) {
      let newSalary = action.payload
      oldState.allSalary = [ newSalary, ...oldState.allSalary]
    },
    updateSalary(oldState, action) {
      let newSalary = action.payload
      let newAllSalary=[...oldState.allSalary]
      .filter((each)=>each.id!==newSalary.id)

      oldState.allSalary = [newSalary, ...newAllSalary]
    },

    openModal(oldState) {
      oldState.isModalOpen = true
    },

    closeModal(oldState) {
      oldState.isModalOpen = false
      oldState.modalViewName = null
      oldState.modalViewParams = null
    },

    setModalViewName(oldState, action) {
      oldState.modalViewName = action.payload
    },

    setModalViewParams(oldState, action) {
      oldState.modalViewParams = action.payload
    },
    setReload(oldState, action) {
      oldState.reload = action.payload
    },
  },

  extraReducers: {
    [fetchAllSalary.pending]: (state, action) => {
      state.status = 'loading'
      state.loading = true
    },
    [fetchAllSalary.fulfilled]: (state, action) => {
      state.status = 'succeeded'
      state.allSalary = action.payload
      state.loading = false
    },
    [fetchAllSalary.rejected]: (state, action) => {
      state.status = 'failed'
      state.error = action.error.message
    },
  },
})

export const reducer = slice.reducer

/* Modal */
export const setModalViewName = (viewName) => (dispatch) => {
  dispatch(slice.actions.setModalViewName(viewName))
}

export const setModalViewParams = (params) => (dispatch) => {
  dispatch(slice.actions.setModalViewParams(params))
}

export const openModal = () => (dispatch) => {
  dispatch(slice.actions.openModal())
}

export const closeModal = () => (dispatch) => {
  dispatch(slice.actions.closeModal())
}

export const setReload = (reload) => (dispatch) => {
  dispatch(slice.actions.setReload(reload))
}

/* Salary disptach */

export const addOrEditSalary = (requestBody) => async (dispatch) => {
  const result = await salaryApi.addOrEditSalary(requestBody)
  if(requestBody.id){
    dispatch(slice.actions.updateSalary(result))
  }else{
    dispatch(slice.actions.addSalary(result))
  }
}


export default slice
